import Vue from 'vue'
import Vuex, {Dictionary} from 'vuex'

import appInterface from './appInterface'
import saveGuard from './saveGuard'
import preheaders from './preheaders'
import notifications from './notifications'
import user from './user'
import axios, {AxiosRequestConfig} from 'axios'
import config from '../config'
import errors from '../services/errors-D'
import auth from '../services/auth'
import LoaderBar from '../services/loaderBar'
import wiki from './wiki'
import resp from './resp'
import sched from './sched'
import messages from './messages'
import newsfeeds from './newsfeeds'
import {getCheckedLang, getLang, LANG_KEY} from '@/services/langStorage';
import router from '@/routes'

import {CONF_BASE_URL, API} from '@/constants'

import {RootState} from '@/types/store/states'

Vue.use(Vuex)

export default new Vuex.Store<RootState>({
  modules: {
    saveGuard,
    appInterface,
    preheaders,
    user,
    notifications,
    wiki,
    resp,
    sched,
    messages,
    newsfeeds
  },
  // @ts-ignore
  state: {
    sidebarOpened: false,
    sidebarMinimized: false,
    bodyMaximized: false,
    resizePanelsHovered: false,
    serverTime: 0,
    lang: getCheckedLang() || getLang(LANG_KEY) || 'en',
    isWidget: false
  },
  mutations: {
    sidebarOpened: (state, opened) => {
      state.sidebarOpened = opened !== undefined ? opened : !state.sidebarOpened
    },
    sidebarMinimized: (state, minimized) => {
      state.sidebarMinimized = minimized !== undefined ? minimized : !state.sidebarMinimized
    },
    bodyMaximized: (state, maximized) => {
      state.bodyMaximized = maximized !== undefined ? maximized : !state.bodyMaximized
    },
    resizePanelsHovered: (state, hovered) => {
      state.resizePanelsHovered = hovered !== undefined ? hovered : !state.resizePanelsHovered
    },
    setServerTime: (state, serverTime) => {
      state.serverTime = Number(serverTime);
    },
    setLang: (state, lang) => {
      state.lang = lang;
    },
    setWidget: (state, isWidget) => {
      state.isWidget = isWidget;
    }
  },
  getters: {
    sidebarOpened: store => store.sidebarOpened,
    sidebarMinimized: store => store.sidebarMinimized,
    bodyMaximized: store => store.bodyMaximized,
    resizePanelsHovered: store => store.resizePanelsHovered
  },
  actions: {
    async apiRequest (context, {url = '/cproc', methodUrl, method, data = {}, flag, contentType = 'application/json', refresh = false}) {
      const HTTP = axios.create({
        baseURL: config(CONF_BASE_URL),
        validateStatus: () => true
      })
      try {
        const headers: Dictionary<string> = {
          'Content-Type': contentType
        }
        if (auth.readToken()) {
          // headers['Authorization'] = 'Basic ' + auth.readToken()
          headers['Authorization'] = 'Bearer ' + auth.readToken()
        }
        // loadBar.setTime()
        let options: AxiosRequestConfig = {
          method: 'post',
          timeout: flag === 'ignoreTimeout' ? 300000 : 15000,
          headers,
          url
        }

        if (method) {
          options.data = {
            method,
            params: {}
          }
          options.params = method

          if (method === 'cproc/resp_find' || method === 'cproc/resp_get' || method === 'cproc/resp_ans' || method === 'chat.lsnuser/list_messages' || method === 'chat.lsnuser/get_messages' || method === 'chat.lsnuser/post_message' || method === 'cproc/drop_auth' || method === 'cproc/get_code' || method === 'cproc/newsfeed_status' || method === 'cproc/newsfeed_info' || method === 'wiki/node_list' || method === 'wiki/page_list' || method === 'wiki/page_get' || method === 'wiki/node_get' || method === 'cproc/user/calend') {
            options.data.params = data
          }
        } else {
          options.data = data
        }

        let request = HTTP.request(options);
        if (flag !== 'silent') {
          LoaderBar.start(request)
        }
        let response = await request;

        if (response.status === 401) {
          let firstReq = true
          const refToken = auth.readRefreshToken()
          if (refToken && !refresh) {
            firstReq = false
            const url = config(CONF_BASE_URL) + '/openid/refresh';

            axios
              .post(url, {refresh_token: refToken})
              .then(async response => {
                const accessToken = response.data.access_token

                auth.setToken(accessToken)

                const headers: Dictionary<string> = {
                  'Content-Type': contentType
                }
                if (auth.readToken()) {
                  // headers['Authorization'] = 'Basic ' + auth.readToken()
                  headers['Authorization'] = 'Bearer ' + auth.readToken()
                }
                // loadBar.setTime()
                let options: AxiosRequestConfig = {
                  method: 'post',
                  timeout: flag === 'ignoreTimeout' ? 300000 : 15000,
                  headers,
                  url
                }

                if (method === 'cproc/resp_find') {
                  window.location.reload();
                  return;
                }

                if (method) {
                  options.data = {
                    method,
                    params: {}
                  }
                  options.params = method

                  if (method === 'cproc/resp_find' || method === 'cproc/resp_get' || method === 'cproc/resp_ans' || method === 'chat.lsnuser/list_messages' || method === 'chat.lsnuser/get_messages' || method === 'chat.lsnuser/post_message' || method === 'cproc/drop_auth' || method === 'cproc/get_code' || method === 'cproc/newsfeed_status' || method === 'cproc/newsfeed_info' || method === 'wiki/node_list' || method === 'wiki/page_list' || method === 'wiki/page_get' || method === 'wiki/node_get' || method === 'cproc/user/calend') {
                    options.data.params = data
                  }
                } else {
                  options.data = data
                }

                let request = HTTP.request(options);
                try {
                  LoaderBar.start(request)
                  response = await request
                } catch (error) {
                  console.error(error)
                } finally {
                  LoaderBar.stop(request)
                }
                // response = await requester();
              })
          } else {
            router.push('/login')
            context.dispatch('user/logout');
            throw response;
          }
        }

        if (response.data.error) {
          throw response;
        }

        if (context.state.appInterface.networkErrorVissible) {
          context.commit('appInterface/networkErrorVissible', false);
        }
        if (flag !== 'silent') {
          LoaderBar.stop(request)
        }

        // Set serverTime
        if (response.headers['x-servertime']) {
          context.commit('setServerTime', response.headers['x-servertime'])
        }

        return response.data.result || response.data.events
      } catch (error) {
        console.log('LOG: apiRequest -> error', error)
        throw error;
      }
    },
    async logExternal (context, data) {
      const response = await context.dispatch('apiRequest', {
        url: API.cproc.entery,
        method: API.cproc.logExternal,
        flag: 'silent',
        data
      }, {root: true})
      return response;
    }
  }
})